// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* BASIC */
.Login {
  background-color: white;
}

.banner {
  margin-top: 200px;
}

html {
  background-color: #56baed;
}

body {
  font-family: "Poppins", sans-serif;
  height: 100vh;
}

a {
  color: #92badd;
  display: inline-block;
  text-decoration: none;
  font-weight: 400;
}

h2 {
  text-align: center;
  font-size: 16px;
  font-weight: 600;
  text-transform: uppercase;
  display: inline-block;
  margin: 40px 8px 10px 8px;
  color: #cccccc;
}

/* STRUCTURE */
.wrapper {
  display: flex;
  align-items: center;
  flex-direction: column;
  justify-content: center;
  width: 100%;
  min-height: 100%;
  padding: 20px;
}

#formContent {
  border-radius: 10px 10px 10px 10px;
  background: #fff;
  padding: 30px;
  width: 90%;
  max-width: 450px;
  position: relative;
  padding: 0px;
  box-shadow: 0 30px 60px 0 rgba(0, 0, 0, 0.3);
  text-align: center;
  border: 0.5px solid lightgrey;
}

#formFooter {
  background-color: #f6f6f6;
  border-top: 1px solid #dce8f1;
  padding: 25px;
  text-align: center;
  border-radius: 0 0 10px 10px;
}

/* TABS */
h2.inactive {
  color: #cccccc;
}

h2.active {
  color: #0d0d0d;
  border-bottom: 2px solid #5fbae9;
}

/* FORM TYPOGRAPHY*/
input[type=button],
input[type=submit],
input[type=reset] {
  background-color: #56baed;
  border: none;
  color: white;
  padding: 15px 80px;
  text-align: center;
  text-decoration: none;
  display: inline-block;
  text-transform: uppercase;
  font-size: 13px;
  box-shadow: 0 10px 30px 0 rgba(95, 186, 233, 0.4);
  border-radius: 5px 5px 5px 5px;
  margin: 5px 20px 40px 20px;
  transition: all 0.3s ease-in-out;
}

input[type=button]:hover,
input[type=submit]:hover,
input[type=reset]:hover {
  background-color: #39ace7;
}

input[type=button]:active,
input[type=submit]:active,
input[type=reset]:active {
  transform: scale(0.95);
}

input[type=text],
input[type=password] {
  background-color: #f6f6f6;
  border: none;
  color: #0d0d0d;
  padding: 15px 32px;
  text-align: center;
  text-decoration: none;
  display: inline-block;
  font-size: 16px;
  margin: 5px;
  width: 85%;
  border: 2px solid #f6f6f6;
  transition: all 0.5s ease-in-out;
  border-radius: 5px 5px 5px 5px;
}

input[type=text]:focus,
input[type=password]:focus {
  background-color: #fff;
  border-bottom: 2px solid #5fbae9;
}

input[type=text]:placeholder,
input[type=password] {
  color: #cccccc;
}

/* ANIMATIONS */
/* Simple CSS3 Fade-in-down Animation */
.fadeInDown {
  animation-name: fadeInDown;
  animation-duration: 1s;
  animation-fill-mode: both;
}
@keyframes fadeInDown {
  0% {
    opacity: 0;
    transform: translate3d(0, -100%, 0);
  }
  100% {
    opacity: 1;
    transform: none;
  }
}
/* Simple CSS3 Fade-in Animation */
@keyframes fadeIn {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}
.fadeIn {
  opacity: 0;
  animation: fadeIn ease-in 1;
  animation-fill-mode: forwards;
  animation-duration: 1s;
}

.fadeIn.first {
  animation-delay: 0.4s;
}

.fadeIn.second {
  animation-delay: 0.6s;
  border: 0.5px solid lightgrey;
}

.fadeIn.third {
  animation-delay: 0.8s;
  border: 0.5px solid lightgrey;
}

.fadeIn.fourth {
  animation-delay: 1s;
  border: 0.5px solid lightgrey;
}

/* Simple CSS3 Fade-in Animation */
.underlineHover:after {
  display: block;
  left: 0;
  bottom: -10px;
  width: 0;
  height: 2px;
  background-color: #56baed;
  content: "";
  transition: width 0.2s;
}

.underlineHover:hover {
  color: #0d0d0d;
}

.underlineHover:hover:after {
  width: 100%;
}

/* OTHERS */
*:focus {
  outline: none;
}

#icon {
  width: 60%;
}

.mat-badge-content {
  background: #5ea1d8;
}

table,
th,
td {
  border-collapse: collapse;
}

th,
td {
  padding: 5px;
  text-align: center;
}

.img-div-left {
  position: fixed;
  z-index: 999;
  height: 150px;
  width: 150px;
  overflow: visible;
  margin: auto;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
}

.table-following .badge {
  width: 90px !important;
  color: white !important;
  background-color: #5ea1d8;
  cursor: pointer;
}

:host-context(body.theme-dark) .Login {
  background-color: #0a0c10 !important;
  color: #e5e7eb !important;
}
:host-context(body.theme-dark) #formContent {
  background: #1f2937 !important;
  border-color: rgba(148, 163, 184, 0.2) !important;
  color: #e5e7eb !important;
}
:host-context(body.theme-dark) #formFooter {
  background: #111827 !important;
  border-top-color: rgba(148, 163, 184, 0.2) !important;
}
:host-context(body.theme-dark) input[type=text],
:host-context(body.theme-dark) input[type=password] {
  background-color: #111827 !important;
  color: #e5e7eb !important;
  border-color: rgba(148, 163, 184, 0.3) !important;
}
:host-context(body.theme-dark) input[type=text]:focus,
:host-context(body.theme-dark) input[type=password]:focus {
  background-color: #1f2937 !important;
}`, "",{"version":3,"sources":["webpack://./src/app/pages/following/following.component.scss"],"names":[],"mappings":"AAAA,UAAA;AAEA;EACE,uBAAA;AAAF;;AAEA;EACE,iBAAA;AACF;;AACA;EACE,yBAAA;AAEF;;AACA;EACE,kCAAA;EACA,aAAA;AAEF;;AACA;EACE,cAAA;EACA,qBAAA;EACA,qBAAA;EACA,gBAAA;AAEF;;AACA;EACE,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,yBAAA;EACA,qBAAA;EACA,yBAAA;EACA,cAAA;AAEF;;AACA,cAAA;AAEA;EACE,aAAA;EACA,mBAAA;EACA,sBAAA;EACA,uBAAA;EACA,WAAA;EACA,gBAAA;EACA,aAAA;AACF;;AAEA;EAEE,kCAAA;EACA,gBAAA;EACA,aAAA;EACA,UAAA;EACA,gBAAA;EACA,kBAAA;EACA,YAAA;EAEA,4CAAA;EACA,kBAAA;EACA,6BAAA;AACF;;AAEA;EACE,yBAAA;EACA,6BAAA;EACA,aAAA;EACA,kBAAA;EAEA,4BAAA;AACF;;AAEA,SAAA;AAEA;EACE,cAAA;AAAF;;AAGA;EACE,cAAA;EACA,gCAAA;AAAF;;AAGA,mBAAA;AAEA;;;EAGE,yBAAA;EACA,YAAA;EACA,YAAA;EACA,kBAAA;EACA,kBAAA;EACA,qBAAA;EACA,qBAAA;EACA,yBAAA;EACA,eAAA;EAEA,iDAAA;EAEA,8BAAA;EACA,0BAAA;EAKA,gCAAA;AADF;;AAIA;;;EAGE,yBAAA;AADF;;AAIA;;;EAOE,sBAAA;AADF;;AAIA;;EAEE,yBAAA;EACA,YAAA;EACA,cAAA;EACA,kBAAA;EACA,kBAAA;EACA,qBAAA;EACA,qBAAA;EACA,eAAA;EACA,WAAA;EACA,UAAA;EACA,yBAAA;EAKA,gCAAA;EAEA,8BAAA;AADF;;AAIA;;EAEE,sBAAA;EACA,gCAAA;AADF;;AAIA;;EAEE,cAAA;AADF;;AAIA,eAAA;AAEA,uCAAA;AACA;EAEE,0BAAA;EAEA,sBAAA;EAEA,yBAAA;AAFF;AAkBA;EACE;IACE,UAAA;IAEA,mCAAA;EAHF;EAKA;IACE,UAAA;IAEA,eAAA;EAHF;AACF;AAMA,kCAAA;AAiBA;EACE;IACE,UAAA;EAJF;EAMA;IACE,UAAA;EAJF;AACF;AAOA;EACE,UAAA;EAGA,2BAAA;EAIA,6BAAA;EAIA,sBAAA;AAPF;;AAUA;EAGE,qBAAA;AAPF;;AAUA;EAGE,qBAAA;EACA,6BAAA;AAPF;;AAUA;EAGE,qBAAA;EACA,6BAAA;AAPF;;AAUA;EAGE,mBAAA;EACA,6BAAA;AAPF;;AAUA,kCAAA;AACA;EACE,cAAA;EACA,OAAA;EACA,aAAA;EACA,QAAA;EACA,WAAA;EACA,yBAAA;EACA,WAAA;EACA,sBAAA;AAPF;;AAUA;EACE,cAAA;AAPF;;AAUA;EACE,WAAA;AAPF;;AAUA,WAAA;AAEA;EACE,aAAA;AARF;;AAWA;EACE,UAAA;AARF;;AAUA;EACE,mBAAA;AAPF;;AAUA;;;EAIE,yBAAA;AARF;;AAUA;;EAEE,YAAA;EACA,kBAAA;AAPF;;AAUA;EACE,eAAA;EACA,YAAA;EACA,aAAA;EACA,YAAA;EACA,iBAAA;EACA,YAAA;EACA,MAAA;EACA,OAAA;EACA,SAAA;EACA,QAAA;AAPF;;AAWE;EAEC,sBAAA;EACA,uBAAA;EACA,yBAAA;EACA,eAAA;AATH;;AAcE;EACE,oCAAA;EACA,yBAAA;AAXJ;AAcE;EACE,8BAAA;EACA,iDAAA;EACA,yBAAA;AAZJ;AAeE;EACE,8BAAA;EACA,qDAAA;AAbJ;AAgBE;;EAEE,oCAAA;EACA,yBAAA;EACA,iDAAA;AAdJ;AAiBE;;EAEE,oCAAA;AAfJ","sourcesContent":["/* BASIC */\n\n.Login {\n  background-color: white;\n}\n.banner {\n  margin-top: 200px;\n}\nhtml {\n  background-color: #56baed;\n}\n\nbody {\n  font-family: \"Poppins\", sans-serif;\n  height: 100vh;\n}\n\na {\n  color: #92badd;\n  display: inline-block;\n  text-decoration: none;\n  font-weight: 400;\n}\n\nh2 {\n  text-align: center;\n  font-size: 16px;\n  font-weight: 600;\n  text-transform: uppercase;\n  display: inline-block;\n  margin: 40px 8px 10px 8px;\n  color: #cccccc;\n}\n\n/* STRUCTURE */\n\n.wrapper {\n  display: flex;\n  align-items: center;\n  flex-direction: column;\n  justify-content: center;\n  width: 100%;\n  min-height: 100%;\n  padding: 20px;\n}\n\n#formContent {\n  -webkit-border-radius: 10px 10px 10px 10px;\n  border-radius: 10px 10px 10px 10px;\n  background: #fff;\n  padding: 30px;\n  width: 90%;\n  max-width: 450px;\n  position: relative;\n  padding: 0px;\n  -webkit-box-shadow: 0 30px 60px 0 rgba(0, 0, 0, 0.3);\n  box-shadow: 0 30px 60px 0 rgba(0, 0, 0, 0.3);\n  text-align: center;\n  border: 0.5px solid lightgrey;\n}\n\n#formFooter {\n  background-color: #f6f6f6;\n  border-top: 1px solid #dce8f1;\n  padding: 25px;\n  text-align: center;\n  -webkit-border-radius: 0 0 10px 10px;\n  border-radius: 0 0 10px 10px;\n}\n\n/* TABS */\n\nh2.inactive {\n  color: #cccccc;\n}\n\nh2.active {\n  color: #0d0d0d;\n  border-bottom: 2px solid #5fbae9;\n}\n\n/* FORM TYPOGRAPHY*/\n\ninput[type=\"button\"],\ninput[type=\"submit\"],\ninput[type=\"reset\"] {\n  background-color: #56baed;\n  border: none;\n  color: white;\n  padding: 15px 80px;\n  text-align: center;\n  text-decoration: none;\n  display: inline-block;\n  text-transform: uppercase;\n  font-size: 13px;\n  -webkit-box-shadow: 0 10px 30px 0 rgba(95, 186, 233, 0.4);\n  box-shadow: 0 10px 30px 0 rgba(95, 186, 233, 0.4);\n  -webkit-border-radius: 5px 5px 5px 5px;\n  border-radius: 5px 5px 5px 5px;\n  margin: 5px 20px 40px 20px;\n  -webkit-transition: all 0.3s ease-in-out;\n  -moz-transition: all 0.3s ease-in-out;\n  -ms-transition: all 0.3s ease-in-out;\n  -o-transition: all 0.3s ease-in-out;\n  transition: all 0.3s ease-in-out;\n}\n\ninput[type=\"button\"]:hover,\ninput[type=\"submit\"]:hover,\ninput[type=\"reset\"]:hover {\n  background-color: #39ace7;\n}\n\ninput[type=\"button\"]:active,\ninput[type=\"submit\"]:active,\ninput[type=\"reset\"]:active {\n  -moz-transform: scale(0.95);\n  -webkit-transform: scale(0.95);\n  -o-transform: scale(0.95);\n  -ms-transform: scale(0.95);\n  transform: scale(0.95);\n}\n\ninput[type=\"text\"],\ninput[type=\"password\"] {\n  background-color: #f6f6f6;\n  border: none;\n  color: #0d0d0d;\n  padding: 15px 32px;\n  text-align: center;\n  text-decoration: none;\n  display: inline-block;\n  font-size: 16px;\n  margin: 5px;\n  width: 85%;\n  border: 2px solid #f6f6f6;\n  -webkit-transition: all 0.5s ease-in-out;\n  -moz-transition: all 0.5s ease-in-out;\n  -ms-transition: all 0.5s ease-in-out;\n  -o-transition: all 0.5s ease-in-out;\n  transition: all 0.5s ease-in-out;\n  -webkit-border-radius: 5px 5px 5px 5px;\n  border-radius: 5px 5px 5px 5px;\n}\n\ninput[type=\"text\"]:focus,\ninput[type=\"password\"]:focus {\n  background-color: #fff;\n  border-bottom: 2px solid #5fbae9;\n}\n\ninput[type=\"text\"]:placeholder,\ninput[type=\"password\"] {\n  color: #cccccc;\n}\n\n/* ANIMATIONS */\n\n/* Simple CSS3 Fade-in-down Animation */\n.fadeInDown {\n  -webkit-animation-name: fadeInDown;\n  animation-name: fadeInDown;\n  -webkit-animation-duration: 1s;\n  animation-duration: 1s;\n  -webkit-animation-fill-mode: both;\n  animation-fill-mode: both;\n}\n\n@-webkit-keyframes fadeInDown {\n  0% {\n    opacity: 0;\n    -webkit-transform: translate3d(0, -100%, 0);\n    transform: translate3d(0, -100%, 0);\n  }\n  100% {\n    opacity: 1;\n    -webkit-transform: none;\n    transform: none;\n  }\n}\n\n@keyframes fadeInDown {\n  0% {\n    opacity: 0;\n    -webkit-transform: translate3d(0, -100%, 0);\n    transform: translate3d(0, -100%, 0);\n  }\n  100% {\n    opacity: 1;\n    -webkit-transform: none;\n    transform: none;\n  }\n}\n\n/* Simple CSS3 Fade-in Animation */\n@-webkit-keyframes fadeIn {\n  from {\n    opacity: 0;\n  }\n  to {\n    opacity: 1;\n  }\n}\n@-moz-keyframes fadeIn {\n  from {\n    opacity: 0;\n  }\n  to {\n    opacity: 1;\n  }\n}\n@keyframes fadeIn {\n  from {\n    opacity: 0;\n  }\n  to {\n    opacity: 1;\n  }\n}\n\n.fadeIn {\n  opacity: 0;\n  -webkit-animation: fadeIn ease-in 1;\n  -moz-animation: fadeIn ease-in 1;\n  animation: fadeIn ease-in 1;\n\n  -webkit-animation-fill-mode: forwards;\n  -moz-animation-fill-mode: forwards;\n  animation-fill-mode: forwards;\n\n  -webkit-animation-duration: 1s;\n  -moz-animation-duration: 1s;\n  animation-duration: 1s;\n}\n\n.fadeIn.first {\n  -webkit-animation-delay: 0.4s;\n  -moz-animation-delay: 0.4s;\n  animation-delay: 0.4s;\n}\n\n.fadeIn.second {\n  -webkit-animation-delay: 0.6s;\n  -moz-animation-delay: 0.6s;\n  animation-delay: 0.6s;\n  border: 0.5px solid lightgrey;\n}\n\n.fadeIn.third {\n  -webkit-animation-delay: 0.8s;\n  -moz-animation-delay: 0.8s;\n  animation-delay: 0.8s;\n  border: 0.5px solid lightgrey;\n}\n\n.fadeIn.fourth {\n  -webkit-animation-delay: 1s;\n  -moz-animation-delay: 1s;\n  animation-delay: 1s;\n  border: 0.5px solid lightgrey;\n}\n\n/* Simple CSS3 Fade-in Animation */\n.underlineHover:after {\n  display: block;\n  left: 0;\n  bottom: -10px;\n  width: 0;\n  height: 2px;\n  background-color: #56baed;\n  content: \"\";\n  transition: width 0.2s;\n}\n\n.underlineHover:hover {\n  color: #0d0d0d;\n}\n\n.underlineHover:hover:after {\n  width: 100%;\n}\n\n/* OTHERS */\n\n*:focus {\n  outline: none;\n}\n\n#icon {\n  width: 60%;\n}\n.mat-badge-content {\n  background: #5ea1d8;\n}\n\ntable,\nth,\ntd {\n  // border: 1px solid black;\n  border-collapse: collapse;\n}\nth,\ntd {\n  padding: 5px;\n  text-align: center;\n}\n\n.img-div-left {\n  position: fixed;\n  z-index: 999;\n  height: 150px;\n  width: 150px;\n  overflow: visible;\n  margin: auto;\n  top: 0;\n  left: 0;\n  bottom: 0;\n  right: 0;\n}\n\n.table-following{\n  .badge{\n //max-width: unset !important;\n   width:90px !important;\n   color: white !important;\n   background-color: #5ea1d8;\n   cursor: pointer;\n }\n}\n\n:host-context(body.theme-dark) {\n  .Login {\n    background-color: #0a0c10 !important;\n    color: #e5e7eb !important;\n  }\n\n  #formContent {\n    background: #1f2937 !important;\n    border-color: rgba(148, 163, 184, 0.2) !important;\n    color: #e5e7eb !important;\n  }\n\n  #formFooter {\n    background: #111827 !important;\n    border-top-color: rgba(148, 163, 184, 0.2) !important;\n  }\n\n  input[type=\"text\"],\n  input[type=\"password\"] {\n    background-color: #111827 !important;\n    color: #e5e7eb !important;\n    border-color: rgba(148, 163, 184, 0.3) !important;\n  }\n\n  input[type=\"text\"]:focus,\n  input[type=\"password\"]:focus {\n    background-color: #1f2937 !important;\n  }\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
